import { inputWithOptionsUniDriverFactory } from '../InputWithOptions/InputWithOptions.uni.driver';

export const autoCompleteUniDriverFactory = inputWithOptionsUniDriverFactory;
